<template>
  <a-card :bordered="false">
    <search-page-view
      ref="pageList"
      rowKey="proId"
      :itemNames="['name_1']"
      :columns="getColumns()"
      :col="4"
      :queryParams="queryParams"
      :requestPromise="getListPromise"
      :buttonItems="['update']"
    >
      <a-form-item slot="name_1" label="商品名称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.proName" placeholder="请输入商品名称"/>
      </a-form-item>
      <template slot="userSlot" slot-scope="rowItem">
        <div>{{ rowItem.record.contactName }}</div>
        <div>{{ rowItem.record.phone }}</div>
      </template>
    </search-page-view>
  </a-card>
</template>

<script>
import SjlHotelMixins from '@/views/service/serviceProvider/sjlHotel/mixins/SjlHotelMixins'

export default {
  name: 'SjlHotelOrderList',
  mixins: [SjlHotelMixins],
  data() {
    return {
      queryParams: {
        proName: '',
        orderType: 34
      },
      searchItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 }
      }
    }
  },
  methods: {
    getListPromise(params) {
      return this.getHttpServices().getOrderService().post('direct/getDirectOrderPage', params)
    },
    getColumns() {
      return [
        {
          title: '订单号（捷旅）',
          dataIndex: 'supplerOrderNo'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '26%'
        },
        {
          title: '下单用户',
          dataIndex: 'contactName',
          scopedSlots: { customRender: 'userSlot' }
        },
        {
          title: '订单来源',
          dataIndex: 'sourceStr'
        },
        {
          title: '订单状态',
          dataIndex: 'statusStr'
        },
        {
          title: '下单时间',
          dataIndex: 'createTime'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
